<template>
    <div>
        <div class="d-flex justify-space-between mb-2">
            <div class="d-flex justify-center align-center">
                <div class="img_title_bill_retrospect_all">
                    <img src="@/assets/icon-restaurant-bill.png">
                </div>
                <h2 class="title_bill_retrospect_all">รายละเอียดใบกำกับภาษี</h2>
            </div>

            <v-btn class="grad-primary-bg white--text titlefont_bill_retrospect_all" height="50" width="20%"
                @click="$router.push('/billretrospectall')">
                ย้อนกลับ
            </v-btn>
        </div>
        <v-slide-x-reverse-transition>
            <!-- # <v-alert type="success" class="alert_success">ยกเลิกบิลเรียบร้อย</v-alert> -->
        </v-slide-x-reverse-transition>

        <v-card class="mb-5">
            <div v-if="loading_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_page === false">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <div style="padding:20px 60px;border:1px solid #1E1E1E">
                                <p class="mb-0" style="text-align:center;font-size:20px;color:#058DC2;font-weight:500">
                                    ใบเสร็จรับเงิน
                                    / ใบกำกับภาษี</p>
                                <p class="mb-0" style="text-align:center;font-size:15px;color:#000000;font-weight:500">
                                    <u>ต้นฉบับ</u>
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3"></v-col>
                        <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" style="display: grid;align-items:center">
                            <p class="mb-0" color="#1E1E1E" style="font-size:15px;font-weight:500;">
                                <span style="color:#058DC2">วันที่ </span>08/05/2567
                            </p>
                            <p class="mb-0" color="#1E1E1E" style="font-size:15px;font-weight:500;">
                                <span style="color:#058DC2">เลขที่ </span>IV2024058000001
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <div>
                                <p class="" color="#3B3B3B" style="font-size:16px;font-weight:400;">ห้างหุ้นส่วนจำกัด.
                                    ก๋างโต้งฟู๊ด (สำนักงานใหญ่)</p>
                                <p class="" color="#3B3B3B" style="font-size:16px;font-weight:400;">เลขที่ 633/144 หมู่
                                    4 ต.หนองจ๊อม อ.สันทราย จ.เชียงใหม่ 50290</p>
                                <p class="" color="#3B3B3B" style="font-size:16px;font-weight:400;">
                                    เลขประจำตัวผู้เสียภาษี 0-5035-60007-07-6 </p>
                            </div>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3"></v-col>
                        <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <img :src="image_mockup" alt="logo" style="width:120px;height:120px;">
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <p style="color:#058DC2;font-size:16px;font-weight:400;">ลูกค้า&nbsp;<span
                                    style="color:#3B3B3B;">ห้างหุ้นส่วนจำกัด. ก๋างโต้งฟู๊ด
                                    (สำนักงานใหญ่)<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เลขที่
                                    633/144 หมู่ 4 ต.หนองจ๊อม อ.สันทราย จ.เชียงใหม่ 50290</span></p>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <p style="color:#3B3B3B;font-size:16px;font-weight:400">เลขประจำตัวผู้เสียภาษี
                                0-5035-60007-07-6</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead class="top-invoice-border">
                                        <tr style="color:#3B3B3B;">
                                            <th class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    ลำดับ
                                                </p>
                                            </th>
                                            <th class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    รายการ
                                                </p>
                                            </th>
                                            <th class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    จำนวน
                                                </p>
                                            </th>
                                            <th class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    ราคาต่อหน่วย
                                                </p>
                                            </th>
                                            <th class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    จำนวนเงิน
                                                </p>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="invoice_border invoice_border_last_data">
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td>
                                                <!-- ถ้ามี Topic ให้ใส่ margin top 10px; ถ้าไม่มี Topic ให้เอาออก -->
                                                <p class="mb-0" style="font-size:16px;font-weight:300;margin-top:10px;">ยำวุ้นเส้น</p>
                                                <div style="text-indent: 25px;font-size:16px;font-weight:300">
                                                    <li>ท๊อปิ้งเพิ่ม</li>
                                                    <li>ท๊อปิ้งเพิ่ม</li>
                                                    <li>ท๊อปิ้งเพิ่ม</li>
                                                    <li>ท๊อปิ้งเพิ่ม</li>
                                                    <li>ท๊อปิ้งเพิ่ม</li>
                                                    <li>ท๊อปิ้งเพิ่ม</li>
                                                    <li>ท๊อปิ้งเพิ่ม</li>
                                                    <li>ท๊อปิ้งเพิ่ม</li>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">150.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">150.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">2</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำคะน้ากุ้งสด</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">3</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">4</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">5</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">6</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">7</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">8</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">9</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">10</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">11</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ไข่เจียวหมูสับ</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">40.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">40.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">12</p>
                                            </td>
                                            <td>
                                                <!-- ถ้ามี Topic ให้ใส่ margin top 10px; ถ้าไม่มี Topic ให้เอาออก -->
                                                <p class="mb-0" style="font-size:16px;font-weight:300;margin-top:10px;">
                                                    ข้าวสวยหอมมะลิ จาน/โถ </p>
                                                <div style="text-indent: 25px;font-size:16px;font-weight:300">
                                                    <li>ท๊อปิ้งเพิ่ม</li>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">13</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    น้ำพริกคางกุ้งต้มยำ</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">3</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">3</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">3</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">3</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">3</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">20</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">21</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">22</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">23</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">24</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">25</p>
                                            </td>
                                            <td>
                                                <p class="mb-0" style="font-size:16px;font-weight:300;">
                                                    ยำถั่วพลูไข่ต้ม</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:300">1</p>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div>
                                                    <p class="mb-0" style="font-size:16px;font-weight:300">190.00</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot class="invoice_border">
                                        <tr style="color:#3B3B3B;">
                                            <td colspan="3" class="text-right"></td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    รวมเงิน</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    5,295.00</p>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td colspan="3" class="text-left">
                                                <p class="mb-0"
                                                    style="font-size:16px;font-weight:400;color:#3B3B3B; padding-left:60px">
                                                    (ห้าพันห้าร้อยห้าสิบเก้าบาทเจ็ดสิบห้าสตางค์)</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    มูลค่าไม่มีภาษี</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    4,948.60</p>
                                            </td>
                                        </tr>

                                        <tr style="color:#3B3B3B;">
                                            <td colspan="3" class="text-right"></td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    ภาษี 7%</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    346.40</p>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td colspan="3" class="text-right"></td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    ค่าบริการ 5%</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    264.75</p>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td colspan="3" class="text-left">
                                                <p class="mb-0"
                                                    style="font-size:16px;font-weight:400;color:#058DC2; padding-left:60px">
                                                    การชำระเงิน : <span style="color:#3B3B3B;">เงินสด</span></p>
                                            </td>
                                            <td class="text-center"
                                                style="border-bottom: 1px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    จำนวนเงินทั้งสิ้น</p>
                                            </td>
                                            <td class="text-center"
                                                style="border-bottom: 1px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    5,559.75</p>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td colspan="3"></td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    ส่วนลด</p>
                                            </td>
                                            <td class="text-center">
                                                <p class="mb-0" style="font-size:16px;font-weight:400;color:#3B3B3B;">
                                                    0.00</p>
                                            </td>
                                        </tr>
                                        <tr style="color:#3B3B3B;">
                                            <td colspan="3"></td>
                                            <td class="text-center"
                                                style="border-bottom: 2px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:500;color:#058DC2;">
                                                    ยอดชำระ</p>
                                            </td>
                                            <td class="text-center"
                                                style="border-bottom: 2px solid #058DC2 !important;">
                                                <p class="mb-0" style="font-size:16px;font-weight:500;color:#3B3B3B;">
                                                    5,559.75</p>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </div>
        </v-card>

        <v-card>
            <v-card-title style="font-size:20px;color:#000;font-weight:600;">
                ผู้ดำเนินการ
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                        <p style="color:#058DC2;font-size:16px;font-weight:400;">ผู้สร้างใบกำกับภาษี <span
                                style="color:#3B3B3B;">: Admin Anda</span>
                        </p>
                        <p style="color:#058DC2;font-size:16px;font-weight:400;">วันที่ <span
                                style="color:#3B3B3B;">:
                                08/05/2024 19:37:15 น.</span>
                        </p>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <p style="color:#058DC2;font-size:16px;font-weight:400; text-align:right">จำนวนการพิมพ์
                            <span style="color:#3B3B3B;">:
                                2 ครั้ง</span>
                        </p>
                        <div style="text-align:right">
                            <v-btn color="success" class="print_invoice_button confirm_invoice_button" @click="likePage('/billinvoiceprint');"
                                height="40">
                                พิมพ์ใบกำกับภาษี
                            </v-btn>
                        </div>

                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import before_image from "@/assets/ZoftConnect_Logo_Black_for_Bill_150px.png";
export default {
    name: 'billretrospect',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            image_mockup: before_image
        }
    },
    methods: {
        likePage(page) {
            window.open(page, '_blank');
        }
    },
    mounted() {
    },
    watch: {
    }
}
</script>
<style>
.confirm_invoice_button {
    width: 50% !important;
}

.top-invoice-border>tr>th {
    border-top: 2px solid #058DC2 !important;
    border-bottom: 2px solid #058DC2 !important;
}

.invoice_border>tr>td {
    border: none !important;
}

.invoice_border_last_data>tr:last-child td {
    border-bottom: 2px solid #058DC2 !important;
}

.print_invoice_button {
    background-image: linear-gradient(to bottom, #51BDE7, #058DC2);
    border-radius: 5px;
}

@media screen and (max-width: 768) {
    .confirm_invoice_button {
        width: 100% !important;
    }
}
</style>